<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="card card-body mb-3">
          <v-user-profile-update />
        </div>
      </div>
      <div class="col-md-6">
        <div class="card card-body mb-3">
          <div class="mb-3">
            <h5 class="text-bold">
              {{ $t('word.email') }}
            </h5>
            <div>
              {{ user.username }}
            </div>
          </div>
          <div class="d-flex flex-column align-items-end">
            <v-button
              id="profile-change-email"
              text="phrase.change_email"
              size="xs"
              style-type="link"
              @click="modals.changeEmail = true"
            />
            <v-button
              id="profile-reset-password"
              text="phrase.reset_password"
              size="xs"
              style-type="link"
              @click="modals.passwordReset = true"
            />

            <v-button
              id="profile-delete-account"
              text="phrase.delete_my_account"
              size="xs"
              style-type="link text-danger"
              @click="modals.deleteAccount = true"
            />
          </div>
        </div>
        <div class="card card-body mb-3">
          <h5 class="text-bold">{{ $t('word.profile_picture') }}</h5>
          <div class="row">
            <div class="col-md-6">
              <img
                v-if="user.profile.picture"
                :src="user.profile.picture"
                alt=""
                class="img-fluid mb-3"
              />
              <img
                v-else
                src="@/common/assets/img/anonymous.svg"
                alt=""
                class="img-fluid mb-3"
              />
            </div>
            <div class="col-md-6">
              <input
                id="profile-upload-profile-picture-input"
                type="file"
                @change="updateProfilePicture()"
                ref="profilePicture"
                accept="image/*"
                hidden
              />

              <div class="mb-3">
                <v-button
                  id="profile-upload-profile-picture"
                  :text="user.profile.picture ? 'word.update' : 'word.add'"
                  :icon="user.profile.picture ? 'edit' : 'plus'"
                  :block="true"
                  @click="selectFileInput()"
                  :loader="{loading: loadingPicture}"
                />
              </div>
              <div v-if="user.profile.picture">
                <v-button
                  id="profile-delete-profile-picture"
                  text="word.remove"
                  icon="trash"
                  style-type="danger"
                  :block="true"
                  @click="deleteProfilePicture()"
                  :loader="{loading: loadingPicture}"
                />
              </div>

              <div v-if="pictureErrors.length > 0">
                <div
                  class="text-danger"
                  v-for="error in pictureErrors"
                  :key="error"
                >
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-reset-password-modal
      v-if="modals.passwordReset"
      @hide-modal="modals.passwordReset = false"
    />

    <v-change-email-modal
      v-if="modals.changeEmail"
      @hide-modal="modals.changeEmail = false"
    />

    <v-delete-account-modal
      v-if="modals.deleteAccount"
      @hide-modal="modals.deleteAccount = false"
    />
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { mapGetters } from 'vuex';
import api from '@/common/api';
import ResetPasswordModal from '@/common/components/users/ResetPasswordModal.vue';
import ChangeEmailModal from '@/common/components/users/ChangeEmailModal.vue';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import DeleteAccountModal from '@/common/components/users/DeleteAccountModal.vue';
import UserProfileUpdate from '@/common/components/users/UserProfileUpdate.vue';

export default {
  name: 'UserProfile',
  components: {
    'v-button': Button,
    'v-reset-password-modal': ResetPasswordModal,
    'v-change-email-modal': ChangeEmailModal,
    'v-delete-account-modal': DeleteAccountModal,
    'v-user-profile-update': UserProfileUpdate,
  },
  data() {
    return {
      divClass: 'bg-danger',
      loadingPicture: false,
      pictureErrors: [],
      modals: {
        passwordReset: false,
        changeEmail: false,
        deleteAccount: false,
      },
      showChangeEmailModal: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    setBreadcrumbs('userProfile');
    if (this.$route.query.changeEmail) {
      this.showChangeEmailModal = true;
    }
  },
  methods: {
    async deleteProfilePicture() {
      this.loadingPicture = true;
      await api.delete('users/profile-picture/');
      this.$store.commit('setProfilePicture', { picture: null });
      this.loadingPicture = false;
    },
    async updateProfilePicture() {
      this.loadingPicture = true;
      const formData = new FormData();
      formData.append('picture', this.$refs.profilePicture.files[0]);
      const response = await api.patch(
        'users/profile-picture/',
        formData,
        { 'Content-Type': 'multipart/form-data' },
      );

      if (response.status === 400) {
        this.loadingPicture = false;
        this.pictureErrors = response.data.picture;
        return;
      }

      this.loadingPicture = false;
      this.$store.commit('setProfilePicture', response.data);
    },
    selectFileInput() {
      this.$refs.profilePicture.click();
    },
  },
};
</script>
